module.exports = __webpack_public_path__ + "img/29.3bf28c5b.png";